import { createFedopsLogger } from '../../app/services/create-fedops-logger';
import { FEDOPS_APP_NAME } from '../constants/fedops';

export default createFedopsLogger(FEDOPS_APP_NAME);
